import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../Redux/Slice/AxiosInstance/AxiosInstance";
import Cookies from "js-cookie";

const DataBase = Cookies.get("Database");

export const SalaryTF = createAsyncThunk("Payroll/SalaryTF", async (data) => {
  try {
    const response = await api.post(
      `/Payroll/SalaryTF`,
      {
        FirmIDs: data.Firm,
        
        DataBase: DataBase,
      },
    
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const SalaryStatement = createAsyncThunk(
  "Payroll/SalaryStatement",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/SalaryStatement`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year ? data.Year : "",
          MonthIDs: data.MonthIDs ? data.MonthIDs : "",
          DeptGrpIDs: data.DeptGrpIDs ? data.DeptGrpIDs : "",
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const DeptList = createAsyncThunk("Payroll/DeptList", async (data) => {
  try {
    const response = await api.post(
      `/Payroll/DeptList`,
      {
        FirmIDs: data.Firm,
        AcYearIDs: data.Year,
        DataBase: DataBase,
        
      },
    
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const DeptGrpList = createAsyncThunk(
  "Payroll/DeptGrpList",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/DeptGrpList`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year,
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const DeptGrpSalTotal = createAsyncThunk(
  "Payroll/DeptGrpSalTotal",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/DeptGrpSalTotal`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year,
          MonthIDs: data.MonthIDs ? data.MonthIDs : "",
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const DeptGrpSalSumm = createAsyncThunk(
  "Payroll/DeptGrpSalSumm",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/DeptGrpSalSumm`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year,
          MonthIDs: data.MonthIDs ? data.MonthIDs : "",
          DeptGrpIDs: data.DeptGrpIDs ? data.DeptGrpIDs : "",
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const EmployeeProfile1 = createAsyncThunk(
  "Payroll/EmployeeProfile",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/EmployeeProfile`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year,
          EmplIDs: data.EmplIDs ? data.EmplIDs : "",
          DeptGrpIDs: data.DeptGrpIDs ? data.DeptGrpIDs : "",
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const EmplList = createAsyncThunk("Payroll/EmplList", async (data) => {
  try {
    const response = await api.post(
      `/Payroll/EmplList`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        
      },
    
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const EmployeeSalary = createAsyncThunk(
  "Payroll/EmployeeSalary",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/EmployeeSalary`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year,
          EmplIDs: data.EmplIDs ? data.EmplIDs : "",
          DeptGrpIDs: data.DeptGrpIDs ? data.DeptGrpIDs : "",
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const EmployeeAttendance = createAsyncThunk(
  "Payroll/EmployeeAttendance",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/EmployeeAttendance`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year,
          EmplIDs: data.EmplIDs ? data.EmplIDs : "",
          DeptGrpIDs: data.DeptGrpIDs ? data.DeptGrpIDs : "",
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const EmployeeProfileDtl = createAsyncThunk(
  "Payroll/EmployeeProfileDtl",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/EmployeeProfileDtl`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year,
          EmplIDs: data.EmplIDs ? data.EmplIDs : "",
          DeptGrpIDs: data.DeptGrpIDs ? data.DeptGrpIDs : "",
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const EmployeeIncrement = createAsyncThunk(
  "Payroll/EmployeeIncrement",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/EmployeeIncrement`,
        {
          FirmIDs: data.Firm,
          EmplIDs: data.EmplIDs ? data.EmplIDs : "",
          DeptIDs: data.DeptIDs ? data.DeptIDs : "",
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const SalaryDeductSumm = createAsyncThunk(
  "Payroll/SalaryDeductSumm",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/SalaryDeductSumm`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year ? data.Year : "",
          MonthIDs: data.MonthIDs ? data.MonthIDs : "",
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const EmployeeLoanDtl = createAsyncThunk(
  "Payroll/EmployeeLoanDtl",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/EmployeeLoanDtl`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year,
          EmplIDs: data.EmplIDs ? data.EmplIDs : "",
          DeptGrpIDsIDs: data.DeptGrpIDs ? data.DeptGrpIDs : "",
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const DeptPresent = createAsyncThunk(
  "Payroll/DeptPresent",
  async (data) => {
    try {
      const response = await api.post(
        `/Payroll/DeptPresent`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year,
          MonthIDs: data.MonthIDs ? data.MonthIDs : "",
          DaySelect: data.DaySelect ? data.DaySelect : "",
          DeptIDs: data.DeptIDs ? data.DeptIDs : "",
          StartDate: data.StartDate ? data.StartDate : "",
          EndDate: data.EndDate ? data.EndDate : "",
          DataBase: DataBase,
          
        },
      
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const PayrollSlice = createSlice({
  name: "FAS",
  initialState: {
    SalaryStatementdata: null,
    DeptListdata: null,
    DeptGrpSaldata: null,
    DeptGrpSalSummdata: null,
    EmployeeProfile1data: null,
    EmplLisdata: null,
    DeptGrpListdata: null,
    EmployeeSalarydata: null,
    EmployeeAttendancedata: null,
    EmployeeProfileDtldata: null,
    EmployeeIncrementdata: null,
    SalaryDeductSummdata: null,
    EmployeeLoanDtldata: null,
    DeptPresentdata: null,
    status: "idle",
    error: null,
  },
  reducers: {
    SalaryStatementdataFun: (state) => {
      state.SalaryStatementdata = "no";
    },
    DeptGrpSaldataFun: (state) => {
      state.DeptGrpSaldata = "no";
    },
    DeptGrpSalSummdataFun: (state) => {
      state.DeptGrpSalSummdata = "no";
    },
    EmployeeProfile1Fun: (state) => {
      state.EmployeeProfile1data = "no";
    },
    EmployeeAttendanceFun: (state) => {
      state.EmployeeAttendancedata = "no";
    },
    EmployeeSalarydataFun: (state) => {
      state.EmployeeSalarydata = "no";
    },
    EmployeeIncrementFun: (state) => {
      state.EmployeeIncrementdata = "no";
    },
    SalaryDeductSummFun: (state) => {
      state.SalaryDeductSummdata = "no";
    },
    EmployeeLoanDtlFun: (state) => {
      state.EmployeeLoanDtldata = "no";
    },
    DeptPresentFun: (state) => {
      state.DeptPresentdata = "no";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SalaryStatement.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SalaryStatement.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalaryStatementdata = action.payload;
      })
      .addCase(SalaryStatement.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(DeptList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(DeptList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.DeptListdata = action.payload;
      })
      .addCase(DeptList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(DeptGrpSalTotal.pending, (state) => {
        state.status = "loading";
      })
      .addCase(DeptGrpSalTotal.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.DeptGrpSaldata = action.payload;
      })
      .addCase(DeptGrpSalTotal.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(DeptGrpSalSumm.pending, (state) => {
        state.status = "loading";
      })
      .addCase(DeptGrpSalSumm.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.DeptGrpSalSummdata = action.payload;
      })
      .addCase(DeptGrpSalSumm.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(EmployeeProfile1.pending, (state) => {
        state.status = "loading";
      })
      .addCase(EmployeeProfile1.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.EmployeeProfile1data = action.payload;
      })
      .addCase(EmployeeProfile1.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(EmplList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(EmplList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.EmplLisdata = action.payload;
      })
      .addCase(EmplList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(DeptGrpList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(DeptGrpList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.DeptGrpListdata = action.payload;
      })
      .addCase(DeptGrpList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(EmployeeSalary.pending, (state) => {
        state.status = "loading";
      })
      .addCase(EmployeeSalary.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.EmployeeSalarydata = action.payload;
      })
      .addCase(EmployeeSalary.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(EmployeeAttendance.pending, (state) => {
        state.status = "loading";
      })
      .addCase(EmployeeAttendance.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.EmployeeAttendancedata = action.payload;
      })
      .addCase(EmployeeAttendance.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(EmployeeProfileDtl.pending, (state) => {
        state.status = "loading";
      })
      .addCase(EmployeeProfileDtl.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.EmployeeProfileDtldata = action.payload;
      })
      .addCase(EmployeeProfileDtl.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(EmployeeIncrement.pending, (state) => {
        state.status = "loading";
      })
      .addCase(EmployeeIncrement.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.EmployeeIncrementdata = action.payload;
      })
      .addCase(EmployeeIncrement.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(SalaryDeductSumm.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SalaryDeductSumm.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SalaryDeductSummdata = action.payload;
      })
      .addCase(SalaryDeductSumm.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(EmployeeLoanDtl.pending, (state) => {
        state.status = "loading";
      })
      .addCase(EmployeeLoanDtl.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.EmployeeLoanDtldata = action.payload;
      })
      .addCase(EmployeeLoanDtl.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(DeptPresent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(DeptPresent.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.DeptPresentdata = action.payload;
      })
      .addCase(DeptPresent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const {
  SalaryStatementdataFun,
  DeptGrpSaldataFun,
  DeptGrpSalSummdataFun,
  EmployeeProfile1Fun,
  DeptPresentFun,
  EmployeeAttendanceFun,
  EmployeeSalarydataFun,
  EmployeeIncrementFun,
  SalaryDeductSummFun,
  EmployeeLoanDtlFun,
} = PayrollSlice.actions;

export default PayrollSlice.reducer;
